import { render, staticRenderFns } from "./DataCorrection.vue?vue&type=template&id=33548038&scoped=true"
import script from "./DataCorrection.vue?vue&type=script&lang=js"
export * from "./DataCorrection.vue?vue&type=script&lang=js"
import style0 from "./DataCorrection.vue?vue&type=style&index=0&id=33548038&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33548038",
  null
  
)

export default component.exports